<template>
  <div>
    <Section>
      <template #header>
        <div class="font-weight-bold">
          W9 <span class="red--text">- ACTION NEEDED</span>
        </div>

        <v-btn fab x-small dark color="primary" class="mt-n1 ml-auto mr-n1" :to="{ name: 'account/w9/certification' }">
          <v-icon small>mdi-file-document-plus-outline</v-icon>
        </v-btn>
      </template>

      <div>
        In order to receive payment for referrals, Referra must have a W9 on
        file. Please click the link below, fill out the form below for your business,
        to start earning rewards for the referrals your business sends today!
      </div>
    </Section>

    <div class="d-flex justify-center mt-4">
      <v-btn color="primary" width="60%" :to="{ name: 'account/w9/certification' }">
        Get Started
      </v-btn>
    </div>
  </div>
</template>

<script>
  import { Section } from '@/components/pages'

  export default {
    name: 'AccountNoW9Section',

    components: { Section },
  }
</script>